import { render, staticRenderFns } from "./mini-alarm.vue?vue&type=template&id=1b5129a6&"
import script from "./mini-alarm.vue?vue&type=script&lang=js&"
export * from "./mini-alarm.vue?vue&type=script&lang=js&"
import style0 from "./mini-alarm.vue?vue&type=style&index=0&id=1b5129a6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports